import React from "react";

/**
 * Return a render code to manage error or warning message
 */
export const errorWarning = (touched, error, warning) => {
  return (
    (touched && error && (
      <span className="help-block">
        <i className="fa fa-exclamation-circle" aria-hidden="true" /> {error}
      </span>
    )) ||
    (warning && <span className="help-block">{warning}</span>)
  );
};



// WEBPACK FOOTER //
// ./src/modules/NTICore/component/Form/errorWaringFormMessage.js